import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import useOrgUnitAdminRosterEntriesDetail from './UseOrgUnitAdminRosterEntriesDetail';

import OrgUnitAdminRosterEntriesDetailGrid from './OrgUnitAdminRosterEntriesDetailGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminRosterEntriesDetail = () => {
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, orgUnitAthleteEntryIndividualRosterEntryState,
    state, gridState, athleteMeetEventState, onAddEventClicked, onAddBonusEventClicked, onDeleteEventClicked, onDeleteEvent,
    onApprovePendingEventsClicked, onBackClicked, modalState, onModalCanceled, omeMeetOrgUnitAthleteEntryState, omeMeetOrgUnitEntryInfoState,
    errorState, omeMeetOrgUnitEntryRosterPermissionsState } = useOrgUnitAdminRosterEntriesDetail();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_ROSTER_ENTRIES_DETAIL}
        onBackButtonClicked={onBackClicked}
        errorMessage={errorState.general}>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <Headings.H4 className={global.HeaderText}>Athlete: {(state?.athlete?.firstName || state?.athlete?.middleName || state?.athlete?.lastName) ? `${state?.athlete?.firstName || ''} ${state?.athlete?.preferredName !== '' && state?.athlete?.preferredName !== state?.athlete?.firstName ? '"' + state?.athlete?.preferredName + '"' : ''} ${state?.athlete?.middleName || ''} ${state?.athlete?.lastName || ''}` : ''} ({state?.athlete?.competitionGenderTypeName || ''}, {state?.athlete?.ageAtMeet >= 0 ? state?.athlete?.ageAtMeet : ''})</Headings.H4>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <ActionIntraPageButton onClick={onAddEventClicked}>Select Events</ActionIntraPageButton>&nbsp;
            {state.bonusEvents === true && <Fragment><ActionIntraPageButton onClick={onAddBonusEventClicked}>Select Bonus Events</ActionIntraPageButton>&nbsp;</Fragment>}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <OrgUnitAdminRosterEntriesDetailGrid
              gridData={gridState.gridData}
              isLoading={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading}
              onDeleteEventClicked={onDeleteEventClicked}
              showStatusColumn={omeMeetOrgUnitEntryRosterPermissionsState?.objData?.orgUnitAthleteRegistrationAllowed === true &&
                omeMeetOrgUnitEntryInfoState?.objData?.teamOrgUnitName !== 'Unattached'
                ? true : false}
            />
          </div>
        </div>
        <div className="row">
          <div className={style.FloatRight}>
            <div className="col-xs-12 usas-extra-top-margin">
              {state?.athlete?.status === Constants.WORKFLOW_STATUS_EVENT_APPROVAL_REQUIRED &&
                <Fragment><PrimaryButton type="button" onClick={onApprovePendingEventsClicked}>Approve Events</PrimaryButton>&nbsp;</Fragment>}
            </div>
          </div>
        </div>
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={modalState.modalTitle}
          displayPopUp={modalState.displayPopUp}
          onModalCanceled={onModalCanceled}>
          <div className="row">
            <div className="col-xs-12">
              <p><strong>Athlete:</strong> {(state?.athlete?.firstName || state?.athlete?.middleName || state?.athlete?.lastName) ? `${state?.athlete?.firstName || ''} ${state?.athlete?.preferredName !== '' && state?.athlete?.preferredName !== state?.athlete?.firstName ? '"' + state?.athlete?.preferredName + '"' : ''} ${state?.athlete?.middleName || ''} ${state?.athlete?.lastName || ''}` : ''} ({state?.athlete?.competitionGenderTypeName || ''}, {state?.athlete?.ageAtMeet >= 0 ? state?.athlete?.ageAtMeet : ''})</p>
              <p><strong>Event:</strong> {modalState.eventName}</p>
              <p><strong>Competition Category:</strong> {modalState.eventCompetitionGenderTypeName}</p>
              <p><strong>Age Group:</strong> {modalState.ageGroupName}</p>
              <p><strong>Session:</strong> {modalState.meetSessionName}</p>
              {omeMeetOrgUnitEntryRosterPermissionsState?.objData?.orgUnitAthleteRegistrationAllowed === true && omeMeetOrgUnitEntryInfoState?.objData?.teamOrgUnitName !== 'Unattached' && <p><strong>Status:</strong> {modalState.status}</p>}
              <p><strong>Entry Time:</strong> {modalState.entryTime} {modalState?.qualifyingCourseCode}</p>
              <p><strong>Time Event:</strong> {modalState.timeEvent || ''}</p>
              <p><strong>Bonus Entry:</strong> {modalState.qualifiedAsBonus}</p>
              <p><strong>Override Entry:</strong> {modalState.override}</p>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
              <PrimaryButton type="button" onClick={(e) => onDeleteEvent(e, modalState.individualAthleteMeetEventId)}>Delete</PrimaryButton>
            </div>
          </div>
        </PopUpModal>
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading ||
            omeMeetOrgUnitEntryInfoState.isObjLoading || orgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading
          } />
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={orgUnitAthleteEntryIndividualRosterEntryState.isSaving || athleteMeetEventState.isSaving} />
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminRosterEntriesDetail;